/**
 * Map API error codes/messages to short, actionable UI copy.
 */
const CODE_MESSAGES = {
    AI_QUOTA_EXCEEDED: 'Monthly AI limit reached. Upgrade the plan or try again next month.',
    SEAT_LIMIT_REACHED: 'Seat limit reached. Remove inactive members or upgrade the plan.',
    STORAGE_QUOTA_EXCEEDED: 'Storage limit reached. Delete unused files or upgrade the plan.',
    PROJECT_LIMIT_REACHED: 'Project limit reached. Archive old projects or upgrade the plan.',
    ORG_SUSPENDED: 'This organization is suspended. Contact support.',
    STRIPE_NOT_CONFIGURED: 'Billing is not configured yet. Request an upgrade or ask your admin.',
    PRICE_NOT_CONFIGURED: 'Self-serve upgrade is not available. Submit an upgrade request instead.',
};

const OUTAGE_COPY =
    "We're temporarily unable to reach Coursolo. Please try again in a moment.";

export function friendlyApiError(err, fallback = 'Something went wrong. Please try again.') {
    const data = err?.response?.data;
    const code = data?.code;
    const status = err?.response?.status;

    if (!err?.response && (err?.code === 'ERR_NETWORK' || err?.message === 'Network Error')) {
        return OUTAGE_COPY;
    }
    if (status === 502 || status === 503 || status === 504) {
        return OUTAGE_COPY;
    }

    if (code && CODE_MESSAGES[code]) return CODE_MESSAGES[code];
    const msg = data?.message || err?.userMessage || err?.message;
    if (msg && typeof msg === 'string' && msg.length < 180 && !/^Error:/.test(msg) && !/status code 50[234]/i.test(msg)) {
        return msg;
    }
    if (status === 401) return 'Please sign in again.';
    if (status === 403) return 'You do not have permission for this action.';
    if (status === 402) return CODE_MESSAGES.AI_QUOTA_EXCEEDED;
    if (status === 404) return 'We could not find that item.';
    if (status === 429) return "You're going a bit fast. Wait a few seconds and try again.";
    if (status >= 500) return 'Server issue — try again in a moment.';
    return fallback;
}

export default friendlyApiError;
